import React, { useEffect, useReducer, useState, useRef } from 'react';
import { FxmsData } from "../../datas/FxData";
import { DateUtil } from "../../datas/DateUtil";
import HighchartsReact from "highcharts-react-official";
import highchartsMore from "highcharts/highcharts-more.js";
import Highcharts from "highcharts/highstock";
import noDataToDisplay from "highcharts/modules/no-data-to-display";

highchartsMore(Highcharts);
noDataToDisplay(Highcharts);
Highcharts.setOptions({
  global: {
    timezoneOffset: -9 * 60, // GMT
  },
});
Highcharts.setOptions({
  lang: {
    noData: "데이터가 존재하지 않습니다",
  },
  noData: {
    style: {
      fontSize: "16px",
      color: "#999999"
    }
  }
});

/* 관리대상 상세 - 수집데이터(하이차트) */
export const FxValueDetail = (props) => {
  const { datas } = props;
  const [dataList, setDataList] = useState(null);
  const [psList, setPsList] = useState();
  const chartComponent = useRef(null);
  const [paramObj, setParamObj] = useReducer((prev, next) => {
    return { ...prev, ...next };
  }, {
    moNo: "",
    psId: "",
    psKindName: "1H", // 15M, 1H, 1D
    startDate: getDate(7),
    endDate: getDate(0)
  });
  const [selectedObj, setSelectedObj] = useReducer((prev, next) => {
    return { ...prev, ...next };
  }, {
    psId: "",
    activeButtonIndex: 1,
    startDate: getDate(7),
    endDate: getDate(0)
  });

  // console.log("datas >>", datas);
  // console.log("psList >>", psList);
  // console.log("paramObj >>> ", paramObj)
  // console.log("dataList >>> ", dataList)
  // console.log("dataList.devicePid == moTid >>> ",dataList?.devicePid)
  // console.log("selectedObj >>> ", selectedObj)

  useEffect(() => {
    // 콤보박스
    async function getComboData() {
      const param = datas.moTid;
      const uri = "fxMo/detail/data/ps/"
      const response = await FxmsData.GET(uri.concat(param));
      console.log("getComboData response >>", response.data);
      setPsList(response.data)
    }
    getComboData();
  }, [datas])

  useEffect(() => {
    setParamObj({
      moNo: datas.moNo,
      psId: datas.psId ? datas.psId : psList && psList[0]?.psId
    })
    setSelectedObj({
      psId: datas.psId ? datas.psId : psList && psList[0]?.psId
    })
  }, [psList])

  useEffect(() => {
    const chart = chartComponent.current.chart;
    if (paramObj.psId !== "" && paramObj.moNo !== "" &&
      paramObj.psId !== undefined && paramObj.moNo !== undefined) {
      chart.showLoading();

      async function getDataList() {
        try {
          const param = paramObj;
          const uri = "fxMo/detail/data"
          const response = await FxmsData.GET(uri, param);

          console.log("getDataList response >>", response.data);
          setDataList(response.data);
          chart.hideLoading();
        } catch (error) {
          console.log("error : " + error);
          setDataList({ "min": 0, "avg": 0, "max": 0, "values": [] });
          chart.hideLoading();
        }
      }
      getDataList();
    } else {
      chart.hideLoading();
    }
  }, [paramObj])

  useEffect(() => {
    if (chartComponent.current) {
      const chart = chartComponent.current.chart;
      const data = getData();
      if (data.length > 0) {
        chart.xAxis[0].setExtremes(data[0][0], data[data.length - 1][0]);
      }
    }
  }, [dataList]);

  const getData = () => {
    const chart = chartComponent.current?.chart;
    const data = [];
    if (dataList?.values !== undefined) {
      for (const value of dataList.values) {
        // value 값이 -1이 아닌 경우에만 데이터를 추가합니다.
        if (value.value !== -1) {
          data.push([
            DateUtil.makeDate(value.date).getTime(),
            value.value
          ]);
        }
      }
    }
    return data;
  };

  const getSeriesName = () => {
    const name = psList?.find(obj => obj.psId === selectedObj.psId)?.psName;
    return name;

  }

  const getChartData = () => {
    let psKindName = paramObj.psKindName;
    let tickInterval = 3600 * 1000 * 4;   //default : 4시간

    if (psKindName === "15M") {
      tickInterval = 3600 * 1000 * 1; //1시간
    } else if (psKindName === "1H") {
      tickInterval = 3600 * 1000 * 4; //4시간
    } else if (psKindName === "1D") {
      tickInterval = 3600 * 1000 * 12; //12시간
    }

    return {
      chart: {
        // width: 850,
        renderTo: "container",
        zoomType: 'x',
        backgroundColor: "#313131",
        borderColor: "#303030",
        plotBackgroundColor: "#303030",
        plotBorderColor: "#303030",
        events: {
          load: function () {
            this.showLoading();
          }
        }
      },
      xAxis: {
        type: "datetime",
        tickInterval: tickInterval,
        labels: {
          style: {
            color: "rgba(255,255,255,0.8)"
          },
          formatter: function () {
            const hour = Highcharts.dateFormat('%H', this.value);
            const labelFormat = hour === '00' ? '%m월 %d일' : '%H:%M';
            return Highcharts.dateFormat(labelFormat, this.value);
          }
          // formatter: function () {
          //   return new Date(this.value).toLocaleTimeString('ko-KR', { hour: "numeric", hour12: false });
          // }
        },
        events: {
          afterSetExtremes: function (e) {
            this.setExtremes(e.min, e.max);
          }
        },
      },
      navigator: {
        enabled: true
      },
      rangeSelector: {
        selected: 'all'
      },

      series: [{
        name: getSeriesName(),
        data: getData()
      }],
      legend: {
        enabled: false
      },
      tooltip: {
        formatter: function () {
          return '<span style="font-size: 10px">' + Highcharts.dateFormat('%Y년 %m월 %d일 %H시 %M분', this.x) + '</span><br/>' +
            '<span style="color:' + this.series.color + '">●</span> ' + this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 2, '.', ',') + '</b>';
        }
      },
      loading: {
        style: { backgroundColor: '#313131' }
      },
      credits: {
        enabled: false
      },
    };
  }

  const buttonList = [
    { text: "원천데이터", className: "mngtg", psKindName: "15M", startDate: getDate(0), endDate: getDate(0) },
    { text: "시간단위", className: "mngtg", psKindName: "1H", startDate: getDate(7), endDate: getDate(0) },
    { text: "일단위", className: "mngtg", psKindName: "1D", startDate: getDate(30), endDate: getDate(0) },
  ];

  const arrowButton = [
    {
      text: "<<",
      startDate: "",
      endDate: "",
      onClickEvent: function () {
        handleBtn_arrow(paramObj?.psKindName, "left");
      }
    },
    {
      text: ">>",
      startDate: "",
      endDate: "",
      onClickEvent: function () {
        handleBtn_arrow(paramObj?.psKindName, "right");
      }
    },
  ]

  const handleBtn_unit = (event, index, buttonObj) => {
    // const clicked = buttonObj.psKindName
    console.log("clicked>>>", buttonObj);
    setParamObj({
      psKindName: buttonObj.psKindName,
      startDate: buttonObj.startDate,
      endDate: buttonObj.endDate
    })
    setSelectedObj({
      activeButtonIndex: index,
      startDate: buttonObj.startDate,
      endDate: buttonObj.endDate
    });
  }

  const handleBtn_reSrch = () => {
    let psKindName = paramObj.psKindName
    let temp = 0;
    let index = 0;

    switch (psKindName) {
      case "15M":
        temp = 0;
        index = 0;
        break;
      case "1H":
        temp = 7;
        index = 1;
        break;
      case "1D":
        temp = 30;
        index = 2;
        break;
      default:
        temp = 0;
        index = 0;
        break;
    }

    setParamObj({
      startDate: getDate(temp),
      endDate: getDate(0)
    })
    setSelectedObj({
      activeButtonIndex: index,
      startDate: getDate(temp),
      endDate: getDate(0)
    })
  }

  const handleBtn_arrow = (psKindName, dir) => {
    let temp = 0;
    switch (psKindName) {
      case "15M":
        temp += dir === "left" ? -1 : 1;
        break;
      case "1H":
        temp += dir === "left" ? -7 : 7;
        break;
      case "1D":
        temp += dir === "left" ? -30 : 30;
        break;
      default:
        temp += 0;
        break;
    }
    if (dir === "left") {
      setParamObj({
        startDate: getDateOfTarget(paramObj.startDate, temp)
      });
      setSelectedObj({
        startDate: getDateOfTarget(selectedObj.startDate, temp)
      });
    } else {
      setParamObj({
        endDate: getDateOfTarget(paramObj.endDate, temp)
      });
      setSelectedObj({
        endDate: getDateOfTarget(selectedObj.endDate, temp)
      });
    }

  };

  const handleChnage_psId = (event) => {
    const selected = event.target.value;

    setParamObj({ psId: selected })
    setSelectedObj({ psId: selected })
  }

  function getDate(daysAgo) {
    const today = new Date();
    const targetDate = new Date(today.getTime() - daysAgo * 24 * 60 * 60 * 1000);

    const year = targetDate.getFullYear().toString();
    const month = (targetDate.getMonth() + 1).toString().padStart(2, '0');
    const day = targetDate.getDate().toString().padStart(2, '0');

    return year + month + day;
  }

  function getDateOfTarget(dateString, daysToAdd) {
    const targetDate = new Date(dateString.slice(0, 4), Number(dateString.slice(4, 6)) - 1, dateString.slice(6, 8));
    targetDate.setDate(targetDate.getDate() + daysToAdd);

    const year = targetDate.getFullYear().toString();
    const month = (targetDate.getMonth() + 1).toString().padStart(2, '0');
    const day = targetDate.getDate().toString().padStart(2, '0');

    return year + month + day;
  }

  function formatDate(input) {
    const year = input.slice(0, 4);
    const month = input.slice(4, 6);
    const day = input.slice(6, 8);

    return `${year}.${month}.${day}`;
  }

  return (
    <div>
      <ul>
        {buttonList.map((button, index) => (
          <li key={index}
            className={index === selectedObj.activeButtonIndex ? 'mngtgOn' : 'mngtg'}
            onClick={(event) => handleBtn_unit(event, index, { psKindName: button.psKindName, startDate: button.startDate, endDate: button.endDate })}
          >
            {button.text}
          </li>
        ))
        }
        <li key={"mngtg_rs"}
          className="mngtg"
          style={{ float: "right" }}
          onClick={() => handleBtn_reSrch()}
        >
          다시조회
        </li>
        {datas.psName ? <></> :
          <>
            {/* 기본 셀렉트 선택*/}
            <select
              className="mngtg"
              value={selectedObj.psId}
              onChange={handleChnage_psId}
            >             
              {psList &&
                psList.map((obj) => (
                  <option value={obj.psId}> {obj.psName} </option>
                ))}
            </select>
          </>
        }
        <br />
        <span className="mngtg">&nbsp;&nbsp;
          평균 : {dataList?.avg.toLocaleString("ko-KR") || 0}&nbsp;&nbsp;&nbsp;&nbsp;최소 : {dataList?.min.toLocaleString("ko-KR") || 0}&nbsp;&nbsp;&nbsp;&nbsp;최대 : {dataList?.max.toLocaleString("ko-KR") || 0}
        </span>
        {/* <li key={"mngtg_rs"}
          className="mngtg"
          style={{ float: "right" }}
          onClick={() => handleBtn_reSrch()}
        >
          다시조회
        </li> */}
      </ul>
      <div className="mngtg_bar">
        <span
          className="arrorBtnL"
          onClick={arrowButton[0].onClickEvent}
        >
          <img src="../popArrow.png" className="arrow" />
        </span>
        {formatDate(selectedObj.startDate)} - {formatDate(selectedObj.endDate)}
        <span
          className="arrorBtnR"
          onClick={arrowButton[1].onClickEvent}
        >
          <img src="../popArrow.png" className="arrow" />
        </span>
      </div>
      <div>
        <HighchartsReact
          highcharts={Highcharts}
          options={getChartData('', '', '', '')}
          containerProps={{ style: { width: '100%', height: '100%' } }}
          ref={chartComponent}
        />
      </div>
    </div>
  );
};

